"use client";
import { cn as e } from "../../design/cn.js";
import { getCheckboxStyles as t, getTableCellStyles as n, getTableHeadStyles as r, getTableHeaderStyles as i, getTableRootStyles as a, getTableRowStyles as o } from "./styles.js";
import s, { createContext as c, forwardRef as l, useContext as u, useEffect as d, useRef as f, useState as p } from "react";
import { ArrowDown as m, ArrowUp as h, ChevronsUpDown as g } from "lucide-react";
import { jsx as _, jsxs as v } from "react/jsx-runtime";
// src/components/data-table/table-primitives.tsx
var y = c(null), b = () => {
	let e = u(y);
	if (!e) throw Error("Table components must be used within TableRoot");
	return e;
}, x = l(({ className: n, label: r, indeterminate: i, ...a }, o) => {
	let c = s.useRef(null);
	return s.useImperativeHandle(o, () => c.current), s.useEffect(() => {
		c.current && (c.current.indeterminate = i || !1);
	}, [i]), /* @__PURE__ */ v("label", {
		className: "flex items-center gap-2 cursor-pointer",
		children: [/* @__PURE__ */ _("input", {
			ref: c,
			type: "checkbox",
			className: e(t(), n),
			...a
		}), r && /* @__PURE__ */ _("span", {
			className: "text-xs",
			children: r
		})]
	});
});
x.displayName = "Checkbox";
var S = l(({ className: t, children: n, size: r = "md", variant: i = "default", sticky: o, truncate: s, defaultColumnWidth: c = 200, bordered: l = !1, containerClassName: u = "", header: m, footer: h, ...g }, b) => {
	let x = f(null), [S, C] = p({
		isScrolledLeft: !1,
		isScrolledRight: !1
	}), [w, T] = p(!1);
	d(() => {
		let e = x.current;
		if (!e || typeof ResizeObserver > "u") return;
		let t = () => T(e.scrollWidth > e.clientWidth + 1), n = new ResizeObserver(t);
		return n.observe(e), t(), () => n.disconnect();
	}, []), d(() => {
		let e = x.current;
		if (!e) return;
		let t = () => {
			let { scrollLeft: t, scrollWidth: n, clientWidth: r } = e, i = t > 5, a = t + r < n - 5;
			C({
				isScrolledLeft: i,
				isScrolledRight: a
			});
		};
		return e.addEventListener("scroll", t), t(), () => e.removeEventListener("scroll", t);
	}, []);
	let E = {
		size: r,
		variant: i,
		sticky: o,
		truncate: s,
		scrollState: S,
		defaultColumnWidth: c
	};
	return /* @__PURE__ */ v("div", {
		className: e("w-full bg-card", l && "overflow-hidden rounded-lg border border-border"),
		children: [
			m,
			/* @__PURE__ */ _("div", {
				ref: x,
				tabIndex: w ? 0 : void 0,
				role: w && g["aria-label"] ? "region" : void 0,
				"aria-label": w ? g["aria-label"] : void 0,
				className: e("relative w-full overflow-auto focus-ring-inset", u),
				children: /* @__PURE__ */ _("table", {
					ref: b,
					className: e(a(), t),
					...g,
					children: /* @__PURE__ */ _(y.Provider, {
						value: E,
						children: n
					})
				})
			}),
			h
		]
	});
});
S.displayName = "TableRoot";
var C = l(({ className: t, stuck: n, ...r }, a) => {
	let { variant: o } = b();
	return /* @__PURE__ */ _("thead", {
		ref: a,
		className: e(i(o, n), t),
		...r
	});
});
C.displayName = "TableHeader";
var w = l(({ className: t, children: n, sortable: i, sortDirection: a, onSort: o, columnIndex: s = 0, width: c, style: l, ...u }, d) => {
	let { size: f, variant: p, sticky: y, scrollState: x, defaultColumnWidth: S } = b(), C = y?.columns?.[s] || "none", w = x?.isScrolledRight && C === "left" ? "left" : x?.isScrolledLeft && C === "right" ? "right" : "none", T = () => {
		i && o && o();
	}, E = c ?? S;
	return /* @__PURE__ */ _("th", {
		ref: d,
		className: e(r({
			size: f,
			variant: p,
			sortable: i,
			sticky: C,
			scrolled: w
		}), t),
		onClick: T,
		"data-column-index": s,
		style: {
			width: typeof E == "number" ? `${E}px` : E,
			minWidth: typeof E == "number" ? `${E}px` : E,
			...l
		},
		...u,
		children: /* @__PURE__ */ v("div", {
			className: "flex items-center justify-between gap-2",
			children: [/* @__PURE__ */ _("span", {
				className: "truncate",
				children: n
			}), i && /* @__PURE__ */ _("span", {
				className: "ml-1 inline-flex shrink-0",
				children: a === "asc" ? /* @__PURE__ */ _(h, { className: "h-3 w-3" }) : a === "desc" ? /* @__PURE__ */ _(m, { className: "h-3 w-3" }) : /* @__PURE__ */ _(g, { className: "h-3 w-3 opacity-50" })
			})]
		})
	});
});
w.displayName = "TableHead";
var T = l(({ className: t, hover: n = !0, selected: r, clickable: i, onClick: a, ...s }, c) => {
	let { variant: l } = b();
	return /* @__PURE__ */ _("tr", {
		ref: c,
		className: e(o({
			variant: l,
			hover: n,
			selected: r,
			clickable: i
		}), t),
		onClick: a,
		...s
	});
});
T.displayName = "TableRow";
var E = {
	default: "after:absolute after:inset-x-0 after:bottom-0 after:h-px after:w-full after:bg-border group-last:after:hidden",
	bordered: "border-b group-last:border-b-0",
	borderless: "",
	numericCompact: ""
}, D = l(({ className: t, children: r, columnIndex: i = 0, truncate: a, width: o, style: s, rowHeader: c, ...l }, u) => {
	let { size: d, variant: f, sticky: p, truncate: m, scrollState: h, defaultColumnWidth: g } = b(), v = p?.columns?.[i] || "none", y = h?.isScrolledRight && v === "left" ? "left" : h?.isScrolledLeft && v === "right" ? "right" : "none", x = o ?? g;
	return /* @__PURE__ */ _(c ? "th" : "td", {
		ref: u,
		scope: c ? "row" : void 0,
		className: e(n({
			size: d,
			variant: f,
			sticky: v,
			scrolled: y
		}), c && ["font-normal text-left", E[f]], t),
		"data-column-index": i,
		style: {
			width: typeof x == "number" ? `${x}px` : x,
			minWidth: typeof x == "number" ? `${x}px` : x,
			...s
		},
		...l,
		children: a !== !1 && (m?.enabled || a) ? /* @__PURE__ */ _(k, {
			maxLines: m?.maxLines || 2,
			children: r
		}) : r
	});
});
D.displayName = "TableCell";
var O = l(({ className: t, ...n }, r) => /* @__PURE__ */ _("tbody", {
	ref: r,
	className: e(t),
	...n
}));
O.displayName = "TableBody";
var k = ({ children: t, maxLines: n = 2, className: r }) => {
	let [i, a] = p(!1), [o, s] = p(!1), c = f(null);
	return d(() => {
		let e = c.current;
		if (!e) return;
		let t = parseInt(getComputedStyle(e).lineHeight) * n;
		s(e.scrollHeight > t);
	}, [t, n]), /* @__PURE__ */ v("div", {
		className: e("relative", r),
		children: [/* @__PURE__ */ _("div", {
			ref: c,
			className: e("overflow-hidden transition-all duration-200", !i && "line-clamp-2"),
			style: {
				display: "-webkit-box",
				WebkitBoxOrient: "vertical",
				WebkitLineClamp: i ? "unset" : n
			},
			children: t
		}), o && /* @__PURE__ */ _("button", {
			onClick: (e) => {
				e.stopPropagation(), a(!i);
			},
			className: "mt-1 text-xs text-primary hover:text-primary/80",
			children: i ? "Show less" : "Show more"
		})]
	});
};
k.displayName = "TruncatedCell";
export { x as Checkbox, O as TableBody, D as TableCell, w as TableHead, C as TableHeader, S as TableRoot, T as TableRow, k as TruncatedCell };

//# sourceMappingURL=table-primitives.js.map